@if (type === 'button' || type === 'submit') {
  <button
    class="button"
    [class]="classBindings"
    [disabled]="disabled || state === 'loading'"
    [type]="type"
    (click)="clicked.emit($event)"
    >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
}

@if (type === 'link' && link) {
  <a
    class="button"
    [class]="classBindings"
    [rel]="rel"
    [target]="target"
    (click)="clicked.emit($event)"
    [routerLink]="disabled ? undefined : link"
    >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </a>
}

@if (type === 'link' && href) {
  <a
    class="button"
    [class]="classBindings"
    [rel]="rel"
    [target]="target"
    (click)="clicked.emit($event)"
    [href]="disabled ? 'javascript:void(0);' : href"
    >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </a>
}

<ng-template #buttonContent>
  @if (layout !== 'icon-only') {
    <span part="label">
      <ng-content></ng-content>
    </span>
  }
  @if (layout !== 'label-only') {
    <span part="icon" [appIcon]="icon"></span>
  }

  @if (state === 'loading') {
    <span class="loading-mask">
      <app-spinner [size]="spinnerSizes[size]" fillColor="var(--content-color)"></app-spinner>
    </span>
  }
</ng-template>
